import { WatcherFunction } from '..'
import { watchToastSuccess } from './toast'

export const toastsSagas: ReadonlyArray<WatcherFunction> = [watchToastSuccess]
